import React, { useState, useEffect } from 'react';
import CustomerService from '../../services/WebCustomerService';
import { Snackbar } from '@material-ui/core';
import CustomerInfoForm from  '../../components/Customer/CustomerInfoForm'
import ProfileService from '../../services/WebProfileService';

export default function EditCustomer(props) {
    const [statusOpen, setStatusOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [customer, setCustomer] = useState({}); 
    const [isAdmin, setIsAdmin] = useState(null);

    useEffect(() => {
        ProfileService.getProfile( (results) => {
            setIsAdmin(results.admin);
        });
    },[]);

    useEffect(() => {
        let customerId = props.match.params.customerId;
        if (!isNaN(customerId)) {
            CustomerService.getCustomer(customerId, (data) => {
                setCustomer(data.results);
            });
        }
    }, [props.match.params.customerId]);
 
    function onSave() {
        CustomerService.updateCustomer(customer, (responseData) => {
            setMessage('Customer info saved');
            setStatusOpen(true);
        });
    }

    return (
        <div>
            {customer ? <CustomerInfoForm
                customer={customer}
                onSave={() => onSave()}
                disableEnabled={isAdmin}
                disableNameField={true}
                onCancel={() => props.history.push({ pathname: `/dashboard` })}/> : null}
            <Snackbar
                open={statusOpen}
                message={message}
                variant="success"
                autoHideDuration={3000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center', }}
                onClose={() => setStatusOpen(false)}
            />
        </div>
    );
    
}
